import request from '@/utils/request'
// 下载
export const download = data =>
  request().post('riskLabel/excel/export', data, {
    responseType: 'blob',
  })
//  获取下拉框
export const getRiskList = data => request().post('riskLabel/list', data)
/**
 * 获取 大区 | 业务模式 | 信控区列表
 */
export const getRegionList = data =>
  request().post('business/region/list', data)
//信用主管
export const getListCManager = () => request().get('bp/apply/listCManager')

//业务类型
export const getBusinessList = () => request().get('business/jsonList')

// 获取表格数据
export const getTableData = data =>
  request().post('riskLabel/customer/page', data)
//获取历史表格数据
export const getHistoryTableData = data =>
  request().post('riskLabel/customer/page', data)
